import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OKTA_AUTH } from './okta-auth.token';
import { ENV, isOktaConfigured } from './env.token';

/**
 * Provides the OktaAuth instance for the current portal.
 * @returns EnvironmentProviders
 */
export function provideOktaAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: OKTA_CONFIG,
      useFactory: () => {
        const environment = inject(ENV);
        // When Okta is not configured, provide a minimal config to prevent OktaAuthModule errors
        if (!isOktaConfigured(environment)) {
          return { oktaAuth: null };
        }
        return { oktaAuth: inject(OKTA_AUTH) };
      },
    },
  ]);
}

export { OktaAuthModule } from '@okta/okta-angular';
